module.exports = __webpack_public_path__ + "static/media/open_mail.45d89916.svg";